import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['waitingList'],
  waitingList: (payload: { id: string }): QueryKey => [...queryKeys.all, payload.id],
  timeSlots: (): QueryKey => [...queryKeys.all, 'timeSlot'],
  timeSlot: (payload: { id: string; attemptId: string }): QueryKey => [...(queryKeys.timeSlots() as string[]), payload],
};
